import { useEffect, useMemo, useState } from 'react';
import { useGetNotifications } from '../../hooks/react-query/useUserData';

import { MenuIcon, NotificationIcon, UserIcon } from '../../icons';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../components/ui/Popover';
import Notifications from '../../pages/account/notifications';
import Menu from '../../pages/account/menu';
import clsx from 'clsx';

export const Header = ({
  impersonateUser,
  handleLogout,
  handleDasboardClick,
}) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const fleetAdminJWT = localStorage.getItem('fleetAdminJWT');
  const shouldFallback = localStorage.getItem('shouldFallback');
  const adminJWT = localStorage.getItem('adminJWT');

  const { data: notificationData, isLoading } = useGetNotifications(isLoggedIn);

  const [notificationList, setNotificationData] = useState({});

  const [openNotificationPopover, setPopover] = useState(false);
  const [openMenuPopover, setMenuPopover] = useState(false);

  useEffect(() => {
    if (notificationData && notificationData.data) {
      setNotificationData(notificationData.data);
    }
  }, [notificationData, notificationData?.data]);

  const notificationCount = useMemo(
    () =>
      notificationList && notificationList.notifications
        ? notificationList.notifications.length
        : '',
    [notificationList]
  );

  const handleLogoutClick = () => {
    setMenuPopover(false);
    handleLogout();
  };

  const handleReturnClick = () => {
    const adminJWT = localStorage.getItem('adminJWT');
    const fleetAdminJWT = localStorage.getItem('fleetAdminJWT');
    localStorage.clear();
    window.location.replace(`/impersonate?jwt=${adminJWT || fleetAdminJWT}`);
    // else window.location.replace(`/impersonateFleetAdmin?jwt=${fleetAdminJWT}`);
  };

  const popoverComponent = (
    <Popover
      open={openMenuPopover}
      onOpenChange={(open) => {
        setMenuPopover(open);
      }}
    >
      <PopoverTrigger>
        <div
          className={`flex items-center gap-2 rounded-[40px] ${
            openMenuPopover ? 'bg-primary  p-2' : 'bg-white'
          }`}
        >
          <MenuIcon
            className={`${
              openMenuPopover ? 'stroke-white' : 'stroke-primary'
            }`}
          />
          <UserIcon
            className={`${
              openMenuPopover ? 'stroke-white' : 'stroke-primary'
            }`}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="w-[100vw] h-[100vh] rounded-lg p-0 z-[200]"
        style={{
          backdropFilter: 'blur(17.5px)',
          background: 'rgba(255, 255, 255, 0.75)',
          padding: 0,
        }}
      >
        <Menu
          handleLogout={handleLogoutClick}
          handleMenuState={() => setMenuPopover(false)}
          isImpersonated={!!fleetAdminJWT}
        />
      </PopoverContent>
    </Popover>
  )

  return (
    <div
      className={`w-full h-[60px] lg:h-[72px] flex justify-between lg:px-[78px] pl-5 bg-white sticky max-lg:py-[14px] lg:py-[22px] top-0 z-30`}
    >
      <button type="button" onClick={() => isLoggedIn && handleDasboardClick()}>
        <img src="/Logo.png" className="mr-20" alt="" />
      </button>
      {isLoggedIn && (
        <div className="flex gap-8 items-center ">
          {!!notificationCount && (
            <Popover
              className="w-[100vw] rounded-lg"
              open={openNotificationPopover}
              onOpenChange={(open) => {
                setPopover(open);
              }}
            >
              <PopoverTrigger>
                <div
                  className={clsx(
                    'relative w-8 h-[28px] flex items-center justify-center rounded-full',
                    openNotificationPopover && 'bg-black'
                  )}
                >
                  {notificationCount && !openNotificationPopover && (
                    <div
                      style={{ boxShadow: '0px 0px 4px 0px #D4002A' }}
                      className="absolute h-[4px] w-[4px] bg-primary rounded-full text-center right-[9px] top-[10px]"
                    />
                  )}
                  <NotificationIcon
                    className={
                      openNotificationPopover
                        ? 'stroke-white bg-black rounded-full'
                        : 'fill-white stroke-black'
                    }
                  />
                </div>
              </PopoverTrigger>
              <PopoverContent
                sideOffset={22}
                className="w-[100vw] h-[var(--radix-popper-available-height)] max-h-[calc(100vh-72px)] rounded-lg p-0"
                style={{
                  background: "url('/bg-dashboard.svg')",
                  backgroundSize: 'cover',
                  padding: 0,
                }}
              >
                <Notifications
                  notificationData={notificationList}
                  isLoading={isLoading}
                />
              </PopoverContent>
            </Popover>
          )}
          {impersonateUser && ( (!adminJWT && !shouldFallback) || ((!!adminJWT)) ) ? (
            <div className={`flex flex-row justify-end gap-10`}> 
              <button
                type="button"
                className={`btn btn-secondary text-secondary-button `}
                onClick={handleReturnClick}
              >
                { !fleetAdminJWT ? "Έξοδος" : "Αλλαγή ΑΦΜ"}
              </button>
              {!!fleetAdminJWT && popoverComponent}
            </div>
          ) : popoverComponent}
        </div>
      )}
    </div>
  );
};
